import CookieManager from '../util/cookie_manager';

document.addEventListener('DOMContentLoaded', async () => {
    const cookieManager = new CookieManager();
});